import React from 'react';
import RoundPercentageRender,{RoundPercentageProps} from './RoundPercentageRender';

export const RoundPercentage=({...props}:RoundPercentageProps):JSX.Element=>{
	return <RoundPercentageRender {...props}/>;
};
